import { render } from "./doubleWysbDirection.vue?vue&type=template&id=5e865396&scoped=true"
import script from "./doubleWysbDirection.vue?vue&type=script&lang=js"
export * from "./doubleWysbDirection.vue?vue&type=script&lang=js"

import "./doubleWysbDirection.vue?vue&type=style&index=0&id=5e865396&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e865396"]])

export default __exports__